export default __webpack_public_path__ + "static/media/pdf.9f406495.svg";